<template>
  <div v-if="items" class="nav-links-section-items">
    <ul class="nav-menu-links">
      <li
        v-for="item in items"
        :key="item.key"
        class="menu-text is-medium-bold"
      >
        <!-- Item -->
        <template v-if="item.key === 'products'">
          <button
            class="btn-arrow-down"
            :class="{ active: showProductsSection }"
            @click="$emit('toggle-products-section')"
          >
            <span>{{
              item.title ? item.title : $t('navigation.' + item.key)
            }}</span>

            <IconArrowDown alt="Arrow down icon" class="icon-arrow-down" />
          </button>
        </template>
        <template v-else="item.key === 'search'">
          <div
            class="search-desk"
            :class="{ active: showDeskSearchSection }"
            @click="handleSearchClick"
          >
            <SearchIcon class="icon-search" :filled="true" />
          </div>
        </template>
      </li>
    </ul>
  </div>
  <div v-if="links" class="nav-links-section-links">
    <ul class="nav-menu-links">
      <li
        class="default-hover"
        :class="{
          'active-state': activeRoute.includes(localePath(link.route)),
        }"
        v-for="link in links.filter((l) => l.key !== 'accountArea')"
        :key="link.key"
      >
        <!-- Link -->
        <NuxtLink
          v-if="link.route"
          :to="localePath(link.route)"
          class="menu-text is-medium-bold"
        >
          <span>{{
            link.title ? link.title : $t('navigation.' + link.key)
          }}</span>
        </NuxtLink>
      </li>
      <li class="default-hover" v-if="showShopLink">
        <a
          href="http://shop.bioenologia.com/"
          class="menu-text shop-link is-medium-bold"
          target="_blank"
        >
          <span>{{ $t('navigation.shop') }}</span>
          <IconOut
            alt="Arrow out icon"
            src="@/assets/img/ico/arrow-out.svg?url"
            class="icon-arrow-out"
          />
        </a>
      </li>
    </ul>
  </div>
  <div v-if="mobileMenu" class="nav-links-section-items" data-lenis-prevent>
    <div
      v-if="mobileMenu.some((item) => item.key === 'search')"
      class="search-element"
    >
      <!-- <div class="search-bar">
        <input
          type="text"
          :placeholder="$t('search.whatSearch')"
          class="search-input"
        /> 
        <SearchIconMobile class="icon-search" :filled="true" />
      </div> -->
      <div class="search-element__wrap">
        <Search :indexes="indexes" />
      </div>
    </div>
    <div class="list-container" data-lenis-prevent>
      <ul class="nav-menu-links mobile">
        <!-- Prodotti -->
        <li
          v-if="mobileMenu.some((item) => item.key === 'products')"
          :key="'products'"
          class="menu-text"
          @click="$emit('toggle-mobile-sub-menu')"
        >
          <button class="btn-arrow-down">
            <span>{{
              mobileMenu.find((item) => item.key === 'products').title
                ? mobileMenu.find((item) => item.key === 'products').title
                : $t('navigation.products')
            }}</span>
            <IconArrowDown alt="Arrow down icon" class="icon-arrow-down" />
          </button>
        </li>

        <!-- Altri items -->
        <NuxtLink
          v-for="item in mobileMenu.filter(
            (item) => item.key !== 'search' && item.key !== 'products',
          )"
          :key="item.key"
          :to="localePath(item.route)"
          custom
          v-slot="{ navigate }"
        >
          <li
            class="menu-text"
            @click="navigate"
            @keydown.enter="navigate"
            tabindex="0"
          >
            <span>{{
              item.title ? item.title : $t('navigation.' + item.key)
            }}</span>
          </li>
        </NuxtLink>

        <!-- Shop link -->
        <a
          v-if="showShopLink"
          href="http://shop.bioenologia.com/"
          class="shop-link"
          target="_blank"
        >
          <li class="menu-text">
            <span>{{ $t('navigation.shop') }}</span>
            <IconOut
              alt="Arrow out icon"
              src="@/assets/img/ico/arrow-out.svg?url"
              class="icon-arrow-out"
            />
          </li>
        </a>
      </ul>
    </div>
  </div>
</template>

<script setup>
import SearchIcon from '@/assets/img/ico/search-icon.svg'
import IconOut from '@/assets/img/ico/arrow-out.svg'
import IconArrowDown from '@/assets/img/ico/arrow-down.svg'

const props = defineProps({
  links: Array,
  items: Array,
  mobileMenu: Array,
  showProductsSection: Boolean,
  showDeskSearchSection: Boolean,
})

const { locale } = useI18n()

const showShopLink = computed(() => {
  return locale.value === 'it'
})

const indexes = ['section_vino', 'section_birra']

const route = useRoute()

const activeRoute = computed(() => route.path)

const emit = defineEmits([
  'toggle-products-section',
  'toggle-desk-search-section',
  'close-products-section',
  'toggle-mobile-sub-menu',
])

const handleSearchClick = () => {
  emit('toggle-desk-search-section')
  emit('close-products-section')
}
</script>

<script>
export default {
  name: 'NavigationMenuLinks',
  inheritAttrs: false,
}
</script>

<style lang="scss">
@import './style.scss';
</style>
